/**
 * Dynamically determines the base URL for the current environment
 * 
 * This function uses environment variables to determine the current domain:
 * - NEXT_PUBLIC_BASE_URL (works on both server and client)
 * - VERCEL_PROJECT_PRODUCTION_URL (automatically set by Vercel, server-only)
 * - BASE_URL (fallback environment variable, server-only)
 * 
 * IMPORTANT: This function must return the same value on server and client
 * to avoid React hydration mismatches. Use NEXT_PUBLIC_BASE_URL for consistency.
 * 
 * @returns The base URL with protocol (e.g., "https://www.aktiekunskap.nu")
 */
export function getBaseUrl(): string {
  // Use NEXT_PUBLIC_BASE_URL first (available on both server and client)
  if (process.env.NEXT_PUBLIC_BASE_URL) {
    return process.env.NEXT_PUBLIC_BASE_URL;
  }

  // Server-only fallbacks
  if (typeof window === 'undefined') {
    if (process.env.VERCEL_PROJECT_PRODUCTION_URL) {
      return `https://${process.env.VERCEL_PROJECT_PRODUCTION_URL}`;
    }

    if (process.env.BASE_URL) {
      return process.env.BASE_URL;
    }
  }

  throw new Error('NEXT_PUBLIC_BASE_URL is not set. This is required for consistent server/client rendering.');
}